module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<p><a href=\"")
    ; __append(escapeFn( locals.publicURL ))
    ; __append("\" target=\"_blank\">")
    ; __append(escapeFn( locals.publicURLTruncated ))
    ; __append("</a></p> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/trackers/public_url.ejs
// module id = 817
// module chunks = 1